const THEME_COLOR_KEYS = [
  '--color-primary',
  '--color-primary-light',
  '--color-primary-hover',
  '--color-primary-50',
  '--color-secondary',
  '--color-secondary-light',
];

export function applyTheme(colors) {
  THEME_COLOR_KEYS.forEach((key) => {
    if (colors && colors[key]) {
      document.documentElement.style.setProperty(key, colors[key]);
    }
  });
}

export function resetTheme() {
  THEME_COLOR_KEYS.forEach((key) => {
    document.documentElement.style.removeProperty(key);
  });
}
